export const enum Status {
    Active = 'Active',
    Pending = 'Pending',
    Inactive = 'Inactive',
    Banned = 'Banned'
};

export const Filters = {
    email: 'email',
    roleId: 'roleId'
};

export const multi = [
    Filters.roleId
];

export const text = [
    Filters.email
];
